import i from"styled-components";import{theme as r}from"../../../../theme.js";const n=(o,e)=>o&&e?"18px 1fr 18px":o&&!e?"18px 1fr":!o&&e?"1fr 18px":"1fr",t=({success:o=!1,error:e=!1,focus:s})=>s?"#2A71D4":o?"#00C853":e?"#EA3100":"#CBD5E1",a=({success:o=!1,error:e=!1})=>o?"#00C853":e?"#EA3100":"transparent",p=({success:o=!1,error:e=!1})=>e?"#EA3100":o?"#00C853":"#94A3B8",d=i.div`
  width: ${({fullWidth:o})=>o?"100%":"300px"};
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 4px;
  position: relative;
`,g=i.div`
  height: 56px;
  width: ${({fullWidth:o})=>o?"100%":"300px"};
  border: 1px solid ${({success:o,error:e,focus:s})=>t({success:o,error:e,focus:s})};
  border-radius: ${r.radius}px;
  background-color: ${({disabled:o})=>o?r.colors.gray[50]:r.colors.shades[0]};
  display: grid;
  grid-template-columns: ${({decoratorStart:o,decoratorEnd:e})=>n(o,e)};
  grid-column-gap: ${r.spacing*2}px;
  align-items: center;
  padding: 0 ${r.spacing*2}px;
  box-sizing: border-box;
  > input {
    height: 100%;
    padding: 0;
    border: none;
    background-color: transparent;
    outline: none;
    color: ${r.colors.gray[900]};
    font-size: 16px;
    box-shadow: 0 0 1000px ${r.colors.shades[0]};
    &::placeholder {
      font-size: 16px;
      color: ${r.colors.gray[400]};
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover, 
    &:-webkit-autofill:focus {
      -webkit-text-fill-color: #0F1734;
      box-shadow: 0 0 0px 1000px #FFFFFF inset;
    }
    &.select-field {
      cursor: pointer;
      caret-color: transparent;
    }
  }
  &.no-border {
    border: 1px solid ${({success:o,error:e})=>a({success:o,error:e})};
  }
`,l=i.span`
  font-size: 16px;
  font-weight: 700;
  color: ${r.colors.gray[500]};
`,c=i.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({error:o,success:e})=>p({success:e,error:o})};
  display: block;
  text-align: ${({position:o})=>o};
`;i(c)`
  color: ${r.colors.success[500]};
`,i(c)`
  color: ${r.colors.error[500]};
`;const x=i.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.clickable {
    cursor: pointer;
  }
  &.active {
    > svg {
      transform: rotate(180deg);
    }
  }
  > svg {
    width: 18px;
    height: 18px;
    > g, path {
      fill: ${r.colors.gray[400]};
    }
  }
`,u=i.div`
  position: absolute;
  top: ${({label:o})=>o?"76px":"56px"};
  z-index: 10;
  width: 100%;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: ${r.colors.shades[0]};
  box-shadow: ${r.boxShadow};
`,h=i.div`
  padding: ${r.spacing*3}px ${r.spacing*2}px;
  cursor: pointer;
  > span {
    font-size: 16px;
    color: ${r.colors.gray[900]};
  }
  &:hover, &:focus, &:active {
    background-color: ${r.colors.gray[50]};
    outline: none;
  }
`,f=i.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${r.spacing*2}px;
  padding: 0 0 ${r.spacing*2}px 0;
`,$=i.div`
  border-radius: ${r.radius}px;
  padding: ${r.spacing*1}px ${r.spacing*2}px;
  background-color: ${r.colors.primary[50]};
  color: ${r.colors.primary[500]};
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: ${r.spacing}px;
  cursor: pointer;
  > svg {
    width: 12px;
    height: 12px;
    > g, path {
      fill: ${r.colors.primary[500]};
    }
  }
`,b=i.div`
  min-height: 56px;
  width: ${({fullWidth:o})=>o?"100%":"300px"};
  border: 1px solid ${r.colors.gray[300]};
  border-color: ${({success:o,error:e,focus:s})=>t({success:o,error:e,focus:s})};
  border-radius: ${r.radius}px;
  background-color: ${({disabled:o})=>o?r.colors.gray[50]:r.colors.shades[0]};
  padding: 0 ${r.spacing*2}px;
  box-sizing: border-box;
  .input {
    height: 56px;
    display: grid;
    grid-template-columns: ${({decoratorStart:o,decoratorEnd:e})=>n(o,e)};
    grid-column-gap: ${r.spacing*2}px;
    align-items: center;
    > input {
      height: 100%;
      padding: 0;
      border: none;
      background-color: transparent;
      outline: none;
      color: ${r.colors.gray[900]};
      font-size: 16px;
      &::placeholder {
        font-size: 16px;
        color: ${r.colors.gray[400]};
      }
      &.select-field {
        cursor: pointer;
        caret-color: transparent;
      }
    }
  }
`,m=i(l)`
  font-size: 14px;
  font-weight: 400;
`;export{c as CaptionText,d as Container,b as FieldAutoCompleteMutliContainer,g as FieldContainer,x as FieldIcon,l as FieldLabel,m as FieldLabelLight,h as OptionContainer,u as OptionsContainer,$ as SelectedItem,f as SelectedItemsContainer,t as borderColorPicker,a as borderColorPickerNoBorder};
